// extracted by mini-css-extract-plugin
export default {"faqList":"styles_faqList__ZaFCf","infoTitle":"styles_infoTitle__tsJ3O"};